import { Loader2 } from "lucide-react"

import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import { YesNoCards } from "@/components/agents/setup/yes-no-cards"
import { Button } from "@/components/ui/button"

import { AppointmentFields, type CalendarEventType } from "./conversions-step"
import type { ChatbotSetupStepProps } from "./types"

// IMP-461: the booking decision — yes reveals the calendar connect + event
// type (the same fields the old Conversions step used).
export function BookingStep({
  stepNumber,
  totalSteps,
  data,
  onUpdate,
  onNext,
  onBack,
  processing,
  value,
  onChange,
  connectedCalendars,
  calendlyEventTypes,
  calComEventTypes,
}: Pick<
  ChatbotSetupStepProps,
  "stepNumber" | "totalSteps" | "data" | "onUpdate" | "onNext" | "onBack"
> & {
  processing: boolean
  value: boolean
  onChange: (v: boolean) => void
  connectedCalendars: Record<string, boolean>
  calendlyEventTypes: CalendarEventType[]
  calComEventTypes: CalendarEventType[]
}) {
  const bookingConfigured =
    data.appointment_calendar_kind !== "" &&
    data.appointment_event_type_uri !== ""
  const canContinue = !value || bookingConfigured

  return (
    <WizardLayout
      footer={
        <>
          <Button variant="outline" onClick={onBack} disabled={processing}>
            Back
          </Button>
          <Button onClick={onNext} disabled={processing || !canContinue}>
            {processing && <Loader2 className="size-4 animate-spin" />}
            Continue
          </Button>
        </>
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title="Should I book appointments?"
        description="When a visitor wants an appointment, I can check your calendar and book a time before the chat ends."
      />
      <YesNoCards
        yesLabel="Yes, book appointments"
        yesSub="I'll offer open times from your calendar and book them in the chat."
        noLabel="No, don't book appointments"
        noSub="I'll answer questions, but won't book anything."
        value={value}
        onChange={onChange}
      />

      {value && (
        <AppointmentFields
          data={data}
          onUpdate={onUpdate}
          connectedCalendars={connectedCalendars}
          calendlyEventTypes={calendlyEventTypes}
          calComEventTypes={calComEventTypes}
        />
      )}
    </WizardLayout>
  )
}
